import React from 'react';
import PropTypes from 'prop-types';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import classnames from 'classnames';
import _castArray from 'lodash/castArray';
import _includes from 'lodash/includes';
// Core components
import Card from 'components/core/Card';
import Typography from 'components/core/Typography';

const FormItemsGroup = ({
  children, padding, paddings, title, type,
}) => {
  const cardProps = {
    defaultBackground: type === 'outlined',
    outlined: type === 'outlined',
  };

  const paddingsList = _castArray(paddings);
  const paddingClasses = {
    [`pt-${padding}`]: _includes(paddingsList, 'top'),
    [`pb-${padding}`]: _includes(paddingsList, 'bottom'),
    [`py-${padding}`]: _includes(paddingsList, 'y'),
    [`pl-${padding}`]: _includes(paddingsList, 'left'),
    [`pr-${padding}`]: _includes(paddingsList, 'right'),
    [`px-${padding}`]: _includes(paddingsList, 'x'),
  };

  return (
    <div className={classnames('', paddingClasses)}>
      <Card
        title={title && (
        <Typography type="subtitle2">
          <LocalizedMessage id={title} />
        </Typography>
        )}
        {...cardProps}
      >
        <div className="row">
          {children}
        </div>
      </Card>
    </div>
  );
};

const paddingValues = ['top', 'bottom', 'y', 'left', 'right', 'x'];

FormItemsGroup.propTypes = {
  children: PropTypes.node.isRequired,
  padding: PropTypes.number,
  paddings: PropTypes.oneOfType([
    PropTypes.oneOf(paddingValues),
    PropTypes.arrayOf(PropTypes.oneOf(paddingValues)),
  ]),
  title: PropTypes.string,
  type: PropTypes.oneOf(['outlined']),
};

FormItemsGroup.defaultProps = {
  padding: 3,
  paddings: [],
  title: null,
  type: null,
};

module.exports = FormItemsGroup;



// WEBPACK FOOTER //
// ./components/misc/FormItemsGroup.js